export const unquote = (value) => typeof value === 'string' && value.startsWith("'") && value.endsWith("'")
    ? value.slice(1, value.length - 1)
    : value;
export function html(strings, ...values) {
    const template = document.createElement('template');
    template.innerHTML = values.reduce((acc, v, idx) => acc + v + strings[idx + 1], strings[0]);
    return template;
}
//# sourceMappingURL=utils.js.map